<template>
  <!-- Delete a system: shows what it's linked to, and offers retiring or moving the links first (US 9370) -->
  <b-modal ref="modal" hide-header hide-footer modal-class="sx-confirm" @hidden="reset">
    <div class="sx-confirm__head">
      <span class="sx-confirm__icon"><font-awesome-icon icon="trash-alt"/></span>
      <div>
        <h3 qid="delete-s-title">{{ $t('system_delete.title', { name: system.name }) }}</h3>
        <p v-if="total">{{ $tc('system_delete.linked', total, { count: total }) }}</p>
        <p v-else>{{ $t('system_delete.not_linked') }}</p>
      </div>
    </div>

    <div class="sx-confirm__body">
      <div v-if="impact.length" class="sx-impact">
        <div v-for="item in impact" :key="item.key"><b>{{ item.count }}</b>{{ $tc('system_page.used.' + item.key, item.count) }}</div>
      </div>

      <template v-if="canEdit && total">
        <button type="button" class="sx-option" :class="{ on: choice === 'retire' }" qid="delete-s-choose-retire" @click="choice = 'retire'">
          <font-awesome-icon icon="archive"/>
          <span class="sx-option__grow"><b>{{ $t('system_delete.retire') }}</b><small>{{ $t('system_delete.retire_hint') }}</small></span>
        </button>
        <button type="button" class="sx-option" :class="{ on: choice === 'move' }" qid="delete-s-choose-move" @click="choice = 'move'">
          <font-awesome-icon icon="exchange-alt"/>
          <span class="sx-option__grow"><b>{{ $t('system_delete.move') }}</b><small>{{ $t('system_delete.move_hint') }}</small></span>
        </button>
        <button type="button" class="sx-option" :class="{ on: choice === 'delete' }" qid="delete-s-choose-delete" @click="choice = 'delete'">
          <font-awesome-icon icon="trash-alt"/>
          <span class="sx-option__grow"><b>{{ $t('system_delete.delete') }}</b><small>{{ $t('system_delete.delete_hint') }}</small></span>
        </button>
      </template>

      <div v-if="choice === 'delete' && total" class="v2-field">
        <label class="v2-field__label" for="sx-delete-name">{{ $t('system_delete.type_name') }}</label>
        <b-form-input id="sx-delete-name" v-model="typed" autocomplete="off" :placeholder="system.name" qid="delete-s-type-name"></b-form-input>
      </div>
    </div>

    <div class="sx-confirm__foot">
      <b-button variant="secondary" qid="delete-s-cancel-button" @click="$refs.modal.hide()">{{ $t('systems.delete.cancel') }}</b-button>
      <b-button v-if="choice === 'retire'" variant="success" qid="delete-s-retire-button" @click="pass('retire')">
        <font-awesome-icon icon="archive"/> {{ $t('system_hero.menu.retire').replace('…', '') }}
      </b-button>
      <b-button v-else-if="choice === 'move'" variant="success" qid="delete-s-move-button" @click="pass('move-links')">
        <font-awesome-icon icon="exchange-alt"/> {{ $t('system_where_used.move') }}
      </b-button>
      <b-button v-else variant="danger" :disabled="deleting || (total > 0 && typed.trim() !== system.name.trim())" qid="delete-s-submit-button" @click="remove">
        <font-awesome-icon :icon="deleting ? 'spinner' : 'trash-alt'" :class="{ 'fa-spin': deleting }"/> {{ $t('systems.delete.submit') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';

  export default {
    name: 'SystemDeleteModal',
    props: {
      system: { type: Object, required: true },
      summary: { type: Object, default: null }
    },
    data: function() {
      return {
        choice: 'retire',
        typed: '',
        deleting: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      canEdit() {
        return this.isGranted([this.permissions.SYSTEM_EDIT, this.permissions.SYSTEM_EDIT_OWN], this.system)
          && (!this.getClient.parent || this.system.partition)
          && this.system.lifecycle_status !== 'retired';
      },
      counts() {
        return (this.summary && this.summary.counts) || {};
      },
      total() {
        return this.counts.where_used || 0;
      },
      impact() {
        return ['activities', 'contracts', 'risks', 'measures']
          .filter(key => this.counts[key])
          .map(key => ({ key: key, count: this.counts[key] }));
      }
    },
    methods: {
      show() {
        this.choice = this.canEdit && this.total ? 'retire' : 'delete';
        this.$refs.modal.show();
      },
      reset() {
        this.typed = '';
        this.deleting = false;
      },
      // Retire and move are done by the page, on the Where used tab
      pass(action) {
        this.$refs.modal.hide();
        this.$emit(action);
      },
      remove() {
        let self = this;
        this.deleting = true;
        piincHttp.delete('systems/' + this.system.slug).then(function() {
          self.$refs.modal.hide();
          self.$store.commit('storeUpdateTasks', true);
          self.$store.commit('storeActiveTask', {});
          self.$toastr('success', self.$t('systems.delete.success'));
          self.$emit('deleted');
        }, function() {
          self.deleting = false;
        });
      }
    }
  }
</script>
